/* eslint-disable react/jsx-no-target-blank */
import * as S from './styles';
import ChevronRight from 'components/Icons/ChevronRight';
import { BaseMain } from 'components/BaseMain';
import Button from 'components/Button';
import { Heading } from 'components/Heading';
import { Loading } from 'components/Loading';
import { MainHeader } from 'components/MainHeader';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  CheckMarkSignature,
  DocumentSignature,
  GroupPeople,
  InfoIcon,
  MailSignature,
} from 'components/Icons';
import { BaseContentMain } from 'components/BaseContentMain';
import { BoxContent } from 'components/BoxContent';
import { AmountQualification } from 'components/AmountQualification';
import { DataDetails } from 'components/DataDetails';
import { Banner } from 'components/Banner';
import WarningTriangle from 'components/Icons/WarningTriangle';
// import BuyPackage from 'components/Icons/BuyPackage';
import { QualificationContext } from 'contexts/AvailableQualification';
import moment from 'moment';
import 'moment/locale/pt-br';
import { api } from 'services/api';
import { NotificationBannerContext } from 'contexts/NotificationBannerContext';
import { ClientInfoContext } from 'contexts/ClientInfoContext';
import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { InvoiceStatus } from 'components/InvoiceStatus';
import ConsumptionDetails from './Drawer/ConsumptionDetails';

import { ArrowSync } from 'styled-icons/fluentui-system-regular';
import DetailsSignature from './Drawer/DetailsSignature/DetailsSignature';

import AlterPlan from './Drawer/AlterPlan/AlterPlan';
import { Switch } from 'components/switch/Switch';
import { ErrorCircle } from 'styled-icons/fluentui-system-filled';
import { FeatureContext } from 'contexts/FeaturesContext';
import { ToolTip } from 'components/ToolTip';

// Função personalizada para arredondamento específico
export const customRoundCurrency = (value: number) => {
  try {
    if (Number.isNaN(Number(value))) {
      throw new Error('Invalid money value');
    }

    // Aplicar a regra de arredondamento específica
    const decimalPart = value % 1;
    let roundedValue = value;

    if (decimalPart >= 0.001 && decimalPart <= 0.005) {
      // 0,001 ~ 0,005 = arredondar pra baixo (0,00)
      roundedValue = Math.floor(value * 100) / 100;
    } else if (decimalPart >= 0.006 && decimalPart <= 0.009) {
      // 0,006 ~ 0,009 = arredondar pra cima (0,01)
      roundedValue = Math.ceil(value * 100) / 100;
    }

    const formatMoney = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
    return formatMoney.format(roundedValue).replace(/\s/, ' ');
  } catch (e: any) {
    return e.message;
  }
};

export type indicatorsProps = {
  mes: number;
  ano: number;
  qtd_total_envelopes: number;
  qtd_total_assinantes: number;
  qtd_total_documentos_assinados: number;
  perc_envelopes_assinados: number;
};
export type Iindicator = {
  id_cliente: number;
  id_sl: number;
  qtd_total_envelopes: number;
  qtd_total_assinantes: number;
  qtd_total_documentos_assinados: number;
  perc_envelopes_assinados: number;
  _id: string;
};
export type HistoryOfQualificationProps = {
  date: string;
  value: number;
  id_qualifier_package: number;
  id_qualifier_bought: string;
  type_transaction: string;
  transaction: string;
  qualififer_package: {
    id_qualifier_pack: string;
    name: string;
    type: number;
  };
  children: React.ReactNode;
};

export type DailyQualification = {
  date?: string;
  name_broker: string;
  name_client: string;
};

export const KenloSignature = () => {
  const [indicatorsPerPage, setIindicatorsPerPage] = useState(3);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [indicators, setIndicators] = useState<indicatorsProps[]>([]);
  const [indicator, setIndicator] = useState<Iindicator>();
  const [isOpenDrawerDetails, setIsOpenDrawerDetails] = useState(false);
  const history = useCustomUtilsHistory();
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const [isOpenAlterPlan, setIsOpenAlterPlan] = useState(false);
  const [indicatorSelected, setIndicatorSelected] = useState<any>();
  const [infoQualifier, setinfoQualifier] = useState<any>();
  const [useExceedingEnvelopes, setUseExceedingEnvelopes] = useState(false);
  const [KAdata, setKAdata] = useState<any>(null);
  const [infoToBanner, setInfoToBanner] = useState<any>();
  //eslint-disable-next-line
  const [priceExceedingEnvelopes, setPriceExceedingEnvelopes] = useState<any>(null);
  const [billing, setBilling] = useState<any>()
  const nameUser = localStorage.getItem('name')
  const [isLoading] = useState(true);
  const { dataAgency } = useContext(FeatureContext);
  const { id } = useParams<{
    id: string;
  }>();
  const { setDataBanner, dataBanner } = useContext(NotificationBannerContext);
  const { dataClientInfo } = useContext(ClientInfoContext);

  const showMoreIndicators = () => {
    setIindicatorsPerPage((indicatorsPerPage) => indicatorsPerPage + 3);
  };

  const { dataQualifierBalance, fetchDataQualifierBalance } =
    useContext(QualificationContext);

  useEffect(() => {
    if (
      dataClientInfo?.accessTokenParam &&
      infoQualifier?.contract_balance_product
    ) {
      fetchDataQualifierBalance(
        dataClientInfo?.accessTokenParam,
        dataClientInfo?.idTokenParams,
        infoQualifier?.contract_balance_product,
      );
    }
  }, [
    dataClientInfo?.accessTokenParam,
    fetchDataQualifierBalance,
    dataClientInfo?.idTokenParams,
    dataClientInfo?.id_realstate,
    infoQualifier?.contract_balance_product,
  ]);

  const disableButtonVerMaisIndicators = useMemo(()=>{
    return indicatorsPerPage >= indicators.length
  },[indicatorsPerPage, indicators]);

  function capitalize(str: any): string {
    if (typeof str === 'string') {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      return '';
    }
  }

  useEffect(() => {
    const fetchDataIndicadores = async () => {
      try {
        const { data } = await api.get(`client/indicadores/client`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        const qualificationIndicatorsData = data.data.historia;
        setIndicator(data.data);
        setIndicators(
          qualificationIndicatorsData.sort((a: any, b: any) => {
            if (b.ano === a.ano) {
              return b.mes - a.mes;
            } else {
              return b.ano - a.ano;
            }
          }),
        );
      } catch (error) {
        console.log(error);
      }
    };
    fetchDataIndicadores();
  }, [accessToken, id, idToken]);

  useEffect(() => {
    const fetchComplementaryProducts = async () => {
      try {
        const { data } = await api.get('products', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setinfoQualifier(data.data.find((el: any) => el.id === 7));
        const complements = data.data.find((item: any) => item.id === 7);
        const complement = complements?.complements?.find(
          (item: any) => item.id === 8,
        );
        setUseExceedingEnvelopes(complement?.using || false);
      } catch (error) {
        console.log(error);
      }
    };
    fetchComplementaryProducts();
  }, [accessToken, idToken]);
  useEffect(() => {
    const fetchBilling = async () => {
      try {
        const { data } = await api.get('client/billings/spare/7', {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        });
        setBilling(data.data)
      } catch (error) {
        console.log(error);
      }
    };
    fetchBilling();
  }, [accessToken, idToken]);
  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/signatures/${infoQualifier?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        const KA = data.data.signature_products.find(
          (sig: any) =>
            sig.product.sub_category === infoQualifier?.externalFamily,
        );
        if (KA) setKAdata(KA);
      } catch (error) {
        console.log(error);
      }
    };

    infoQualifier?.id_signature && fetchDataSignatures();
  }, [
    accessToken,
    idToken,
    infoQualifier?.id_signature,
    infoQualifier?.externalFamily,
  ]);
  useEffect(() => {
    const fetchDataPrices = async () => {
      try {
        const { data } = await api.get(
          `external-products/prices/?id_product=${KAdata?.id_product}&frequency=avulso`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setPriceExceedingEnvelopes(data.data.cost);
      } catch (error) {
        console.log(error);
      }
    };
    KAdata?.id_product && fetchDataPrices();
  }, [
    accessToken,
    idToken,
    KAdata
  ]);

  const getBodyPerformance = () => {
    return (
      <>
        {indicators?.slice(0, indicatorsPerPage).map((indicator: any) => {
          return (
            <BoxContent
              key={`${indicator.mes}-${indicator.ano}`}
              style={{
                display: 'flex',
                padding: '1.6rem 2.4rem 1.6rem 2.4rem',
                cursor: 'pointer',
              }}
              color="#E5E5E5"
              onClick={async () => {
                await setIndicatorSelected(indicator);
                setIsOpenDetails(true);
              }}
            >
              <DataDetails
                title={`${indicator.mes === moment().month() + 1
                  ? 'Este mês'
                  : capitalize(
                    `${moment(`${indicator.ano}-${indicator.mes}-01`, [
                      'YYYY-M-DD',
                      'YYYY-MM-DD',
                    ]).format('MMMM')} de ${indicator.ano}`,
                  )
                  }`}
                subtitle={`${indicator.qtd_total_envelopes} envelopes`}
              />
              <S.WrapperAmountQualification>
                <AmountQualification
                  icon={<GroupPeople />}
                  text={indicator.qtd_total_assinantes}
                />
                <AmountQualification
                  icon={<DocumentSignature />}
                  text={indicator.qtd_total_documentos_assinados}
                />
                <AmountQualification
                  icon={<CheckMarkSignature />}
                  text={`${indicator.perc_envelopes_assinados}%`}
                />
              </S.WrapperAmountQualification>
              {indicator.mes === moment().month() + 1 ? (
                <span style={{ alignContent: 'center' }}>
                  {' '}
                  <ChevronRight />{' '}
                </span>
              ) : (
                <span
                  onClick={() => setIsOpenDetails(true)}
                  style={{ alignContent: 'center' }}
                >
                  {' '}
                  <ChevronRight />{' '}
                </span>
              )}
              {/* {PerformaceDetail} */}
            </BoxContent>
          );
        })}
        {!disableButtonVerMaisIndicators && (
          <S.WrapperButtonVerMais>
            <Button
              onClick={showMoreIndicators}
              disabled={disableButtonVerMaisIndicators}
            >
              Ver mais
            </Button>
          </S.WrapperButtonVerMais>
        )}
      </>
    );
  };
  useEffect(() => {
    const fetchDataSignatures = async () => {
      try {
        const { data } = await api.get(
          `client/billings/signature/${infoQualifier?.id_signature}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setInfoToBanner(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    infoQualifier?.id_signature && fetchDataSignatures();
  }, [accessToken, idToken, infoQualifier?.id_signature, ]);

  const pluralize = (count: any, word: any, pluralWord?: any) => {
    return count > 1 ? pluralWord ?? `${word}s` : word;
  };

  const safeCount = (count: any) => count ?? 0;

  const infos = [
    {
      icon: <GroupPeople />,
      title:
        safeCount(indicator?.qtd_total_assinantes) > 0
          ? `${indicator?.qtd_total_assinantes} ${pluralize(
            indicator?.qtd_total_assinantes,
            'pessoa',
          )}`
          : 'Nenhuma pessoa',
      subTitle: `participaram ${pluralize(
        safeCount(indicator?.qtd_total_assinantes),
        'da',
      )} ${pluralize(
        safeCount(indicator?.qtd_total_assinantes),
        'assinatura',
      )}`,
    },
    {
      icon: <DocumentSignature />,
      title:
        safeCount(indicator?.qtd_total_documentos_assinados) > 0
          ? `${indicator?.qtd_total_documentos_assinados} ${pluralize(
            indicator?.qtd_total_documentos_assinados,
            'documento',
          )}`
          : 'Nenhum documento',
      subTitle: `${pluralize(
        safeCount(indicator?.qtd_total_documentos_assinados),
        'assinado',
      )} pelas partes`,
    },
    {
      icon: <CheckMarkSignature />,
      title:
        safeCount(indicator?.perc_envelopes_assinados) > 0
          ? `${indicator?.perc_envelopes_assinados} ${pluralize(
            indicator?.perc_envelopes_assinados,
            '% dos envelopes',
          )}`
          : 'Nenhum envelope',
      subTitle: `${pluralize(
        safeCount(indicator?.perc_envelopes_assinados),
        'concluído',
      )} com sucesso`,
    },
  ];
  const percentage = useMemo(() => {
    const amount = KAdata?.product?.qty_leads ?? KAdata?.amount;

    if (dataQualifierBalance?.balance_premium === 0 || amount === 0) {
      return '0';
    }
    if(Number((((dataQualifierBalance?.balance_contract as number) / amount) * 100).toFixed(2)) > 100) return "100"
    return (((dataQualifierBalance?.balance_premium as number) / amount) * 100)
      .toFixed(2)
      .toString();
  }, [
    dataQualifierBalance?.balance_premium,
    dataQualifierBalance?.balance_contract,
    KAdata?.amount,
    KAdata?.product?.qty_leads,
  ]);
  const AlterExceedingEnvelopes = async (exceedingEnvelopes: boolean) => {
    try {
      await api.patch(
        `/products`,
        {
          using: exceedingEnvelopes,
          id_internal_product: 8,
          log: {
            id_log_type: exceedingEnvelopes ? 3 : 4,
            title: exceedingEnvelopes
              ? 'Envelopes pós-pagos ativados para o Kenlo Assinaturas'
              : 'Envelopes pós-pagos desativados para o Kenlo Assinaturas',
          },
        },
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setUseExceedingEnvelopes(exceedingEnvelopes);
    } catch (error) {
      console.log(error);
    }
  };
  const exceedingEnvelopes = useMemo(() => {
    return dataQualifierBalance?.balance_premium && dataQualifierBalance?.balance_premium < 0
      ? dataQualifierBalance?.balance_premium * -1
      : 0
  }, [dataQualifierBalance?.balance_premium]);
  const openWhatsapp = async () => {
    const message = `Olá, aqui é ${nameUser} da ${dataAgency?.name}. Gostaria de alterar o meu plano do Kenlo Assinaturas. \n Fico no aguardo do retorno.`
    window.open(
      `https://wa.me/5511992359399?text=${message}`,'_blank'
    )
  }
  return (
    <>
      <MainHeader />
      <SubHeader
        title="Detalhes do Produto"
        onReturn={() => history.push('/ClientArea')}
      />
      {!isLoading && <Loading />}
      <BaseMain hideHeader>
        {dataBanner && (
          <S.WrapperBanner>
            <Banner
              icon={<WarningTriangle />}
              text="O boleto do novo pacote contratado já está disponível. O saldo de qualificações será atualizado assim que recebermos o pagamento."
            >
              <a
                href={dataBanner.link2via}
                target="_blank"
                onClick={() => setDataBanner(undefined)}
              >
                Ver boleto
              </a>
            </Banner>
          </S.WrapperBanner>
        )}
        <S.BodyContentWrapper>
          <S.WrapperAside>
            <S.contentAside>
              <S.TitleAside>
                <span className="title">Kenlo Assinaturas</span>
                <InvoiceStatus
                  status={infoQualifier?.status ? 'paga' : 'cancelada'}
                  text={infoQualifier?.status ? 'Ativo' : 'Suspenso'}
                />
              </S.TitleAside>
              <S.TitleAside>
                    <S.TextAside>Envelopes disponíveis</S.TextAside>
                    <S.TextAsideSpan>
                      {dataQualifierBalance?.balance_premium && dataQualifierBalance?.balance_premium > 0 ? dataQualifierBalance?.balance_premium : 0}
                      <S.TextAsideSpan fontSize="12" color="#808080">
                        /{KAdata?.product?.qty_leads ?? KAdata?.amount}
                      </S.TextAsideSpan>
                    </S.TextAsideSpan>
                  </S.TitleAside>
              {dataQualifierBalance?.balance_premium &&
                dataQualifierBalance?.balance_premium > 0 ? (
                <>
         
                  <S.ProgressBar percentage={percentage} />
                </>
              ) : (
                <>
                  <Banner
                    icon={<WarningTriangle />}
                    text={!dataAgency?.defaulter ? "Os envelopes do seu plano acabaram. Você pode utilizar envelopes pós-pagos até o mês encerrar." :
                      "Os envelopes do seu plano acabaram. Você não poderá utilizar envelopes pós-pagos até pagar a fatura atual."
                    }
                  ></Banner>
                </>
              )}
              {infoQualifier?.id_signature ? (
                <>
                  <hr
                    style={{
                      marginLeft: '-24px',
                      marginRight: '-24px',
                      marginBottom: '24px',
                    }}
                  />
                  <S.TitleAside>
                    <S.TextAside fontWeight="700">Cobrança</S.TextAside>
                  </S.TitleAside>
                  <S.Grid>
                    <div>
                      <S.TextAside fontSize="12" color="#808080">
                        Data de contratação
                      </S.TextAside>
                      <S.TextAside>
                        {dataClientInfo?.dgLeadsActivationDate
                          ? moment(
                            dataClientInfo?.dgLeadsActivationDate,
                          ).format('DD/MM/YYYY')
                          : 'Não informado'}
                      </S.TextAside>
                    </div>
                    <div>
                      <S.TextAside fontSize="12" color="#808080">
                        Data de renovação
                      </S.TextAside>
                      <S.TextAside>
                        {moment()
                          .add(1, 'month')
                          .startOf('month')
                          .format('D[º] [de] MMMM')}
                      </S.TextAside>
                    </div>
                  </S.Grid>
                  <div>
                    <S.TextAside fontSize="12" color="#808080">
                      Valor
                    </S.TextAside>
                    <S.TextAside fontSize="20">
                      {customRoundCurrency(infoQualifier?.installmentValue || 0) ||
                        '0,00'}{' '}
                      /
                      {infoQualifier?.planFrequency
                        ? infoQualifier?.planFrequency === 'mensal'
                          ? 'mês'
                          : 'ano'
                        : 'não informado'}
                    </S.TextAside>
                  </div>
                </>
              ) : (
                <></>
              )}
            </S.contentAside>
            <S.contentAside style={{ marginTop: '16px' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  justifyContent: 'space-between',
                }}
              >
                <S.TextAside fontWeight="700" fontSize="20">
                  Envelopes pós-pagos
                </S.TextAside>
                {dataAgency?.defaulter ?        <ToolTip
                  right="2rem"
                  height="3rem"
                  content={
                    "Pague a fatura atual para alterar as definições de envelopes pós-pagos."
                  }
                  icon={
                    <Switch
                    checked={useExceedingEnvelopes}
                    disabled={dataAgency?.defaulter}
                    onChange={() => {
                      AlterExceedingEnvelopes(!useExceedingEnvelopes);
                    }}
                  />
                  }
          
                /> : <Switch
                  checked={useExceedingEnvelopes}
                  disabled={dataAgency?.defaulter}
                  onChange={() => {
                    AlterExceedingEnvelopes(!useExceedingEnvelopes);
                  }}
                />}
              </div>
              {!useExceedingEnvelopes && exceedingEnvelopes > 0 && (
                <Banner
                  style={{ marginTop: '16px' }}
                  icon={<ErrorCircle size={24} style={{ marginRight: '16px' }} />}
                  text={
                    'A fatura será fechada no fim do mês. Reative quando quiser.'
                  }
                ></Banner>
              )}

              {
                <>
                  {/* { !dataAgency?.defaulter && useExceedingEnvelopes && exceedingEnvelopes === 0 && (
                    <S.TextAside style={{ marginTop: '16px' }}>
                      Ao fim do saldo do plano, cada envelope extra terá o valor
                      de {customRoundCurrency(priceExceedingEnvelopes)}.
                    </S.TextAside>
                  )} */}
                  {(exceedingEnvelopes > 0 || billing)&&
                    <>
                      <S.Grid style={{ marginTop: '16px' }}>
                        <div>
                          <S.TextAside fontSize="12" color="#808080">
                            Utilizado
                          </S.TextAside>
                          <S.TextAside>
                            {billing?.compo_billing?.[0]?.products?.[0]?.amount ?? exceedingEnvelopes} envelopes
                          </S.TextAside>
                        </div>
                        {/* <div>
                          <S.TextAside fontSize="12" color="#808080">
                            {billing ? "Data de vencimento" :  "Valor do envelope"}
                          </S.TextAside>
                          <S.TextAside>{billing ? moment(
                            billing.dueDate,
                          ).format('DD/MM/YYYY') : customRoundCurrency(priceExceedingEnvelopes)}</S.TextAside>
                        </div> */}
                        {billing ?      <div>
                          <S.TextAside fontSize="12" color="#808080">
                           Data de vencimento
                          </S.TextAside>
                          <S.TextAside>{moment(
                            billing.dueDate,
                          ).format('DD/MM/YYYY')}</S.TextAside>
                        </div> : <></>}
                  
                      </S.Grid>

                      {/* <div>
                        <S.TextAside fontSize="12" color="#808080">
                          Valor da fatura
                        </S.TextAside>
                        <S.TextAside>{customRoundCurrency(billing?.compo_billing?.[0]?.products?.[0]?.value ?? (exceedingEnvelopes * priceExceedingEnvelopes))}</S.TextAside>
                      </div> */}
                    </>
                  }

                </>
              }

            </S.contentAside>
          </S.WrapperAside>
          <S.WrapperMain>
            {infoToBanner && (
              <>
                {moment(infoToBanner.dueDate).isBefore(
                  moment
                    .tz(new Date(), 'America/Sao_Paulo')
                    .subtract(10, 'days'),
                ) ? (
                  <S.WrapperBanner>
                    <Banner
                      icon={<InfoIcon color="#6C2B22" />}
                      style={{
                        display: 'flex',
                        backgroundColor: '#FAE3E0',
                        color: '#6C2B22',
                        justifyContent: 'space-between',
                      }}
                      text={`Última fatura pendente! Para evitar o cancelamento da sua assinatura, realize o pagamento o quanto antes.`}
                    />
                  </S.WrapperBanner>
                ) : (
                  <S.WrapperBanner>
                    <Banner
                      icon={<InfoIcon />}
                      text={`Última fatura pendente! Entre em contato com o suporte em caso de problemas com o boleto.`}
                    />
                  </S.WrapperBanner>
                )}
              </>
            )}
            <S.contentAside>
              <S.TitleAside>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <MailSignature />
                  <div>
                    <S.TextAside fontSize="32" fontWeight="700">
                      {indicator?.qtd_total_envelopes || 0} envelopes
                    </S.TextAside>
                    <S.TextAside
                      fontSize="16"
                      color="#808080"
                      style={{ marginTop: '8px' }}
                    >
                      foram enviados para assinatura
                    </S.TextAside>
                  </div>
                </div>
              </S.TitleAside>
              <hr style={{ margin: ' 0 -24px ' }} />
              <S.GridInfos>
                {infos.map((el, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    {el.icon}
                    <div>
                      <S.TextAside fontSize="16" fontWeight="700">
                        {el.title}
                      </S.TextAside>
                      <S.TextAside fontSize="12" color="#808080">
                        {el.subTitle}
                      </S.TextAside>
                    </div>
                  </div>
                ))}
              </S.GridInfos>
            </S.contentAside>
            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Serviços adicionais"
                    weight="600"
                    size="large"
                    color="#1A1A1A"
                  />
                </S.WrapperTitle>
              }
            >
              <S.AddButtons
                cursor
                onClick={openWhatsapp}
                fontWeight="700"
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    justifyContent: 'space-between',
                  }}
                >
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <ArrowSync size={24} /> Alterar plano
                  </div>
                </div>

                <S.TextAside fontSize="16" color="#808080" style={{display:"flex"}}>
                  <S.TextAside fontSize="16" color="#F82E52" onClick={openWhatsapp} style={{marginRight:"4px",}} cursor>
                     Entre em contato
                    </S.TextAside>
                    com a nossa equipe para ajustar o plano atual.
                </S.TextAside>
              </S.AddButtons>
            </BaseContentMain>

            <BaseContentMain
              padding="2.4rem 2.4rem 2.4rem 2.4rem"
              title={
                <S.WrapperTitle>
                  <Heading
                    title="Consumo mensal"
                    weight="600"
                    size="large"
                    color="#1A1A1A"
                  />
                </S.WrapperTitle>
              }
            >
              {getBodyPerformance()}
            </BaseContentMain>
          </S.WrapperMain>
        </S.BodyContentWrapper>
      </BaseMain>
      {isOpenDetails && (
        <ConsumptionDetails
          closeDrawer={() => setIsOpenDetails(false)}
          indicator={indicatorSelected}
          idConsumption={dataClientInfo?.id_realstate}
          typeProduct={infoQualifier?.contract_balance_product}
          exceedingEnvelopes={exceedingEnvelopes}
        />
      )}
      {isOpenDrawerDetails && (
        <DetailsSignature
          closeDrawer={() => setIsOpenDrawerDetails(false)}
          signature={KAdata}
          infoQualifier={infoQualifier}
          balance={dataQualifierBalance}
        />
      )}
      {isOpenAlterPlan && (
        <AlterPlan closeDrawer={() => setIsOpenAlterPlan(false)} valueCurrentPlan={infoQualifier?.installmentValue || 0} dateCurrentPlan={moment()
          .add(1, 'month')
          .startOf('month')
          .format('D[º] [de] MMMM')} currentBalance={dataQualifierBalance?.balance_premium || 0} currentTotalBalance={KAdata?.product?.qty_leads ?? KAdata?.amount} />
      )}
    </>
  );
};    
